import { render, staticRenderFns } from "./QAZoneDetail.vue?vue&type=template&id=006ce21a&scoped=true"
import script from "./QAZoneDetail.vue?vue&type=script&lang=js"
export * from "./QAZoneDetail.vue?vue&type=script&lang=js"
import style0 from "./QAZoneDetail.vue?vue&type=style&index=0&id=006ce21a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006ce21a",
  null
  
)

export default component.exports